import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "product-detail-top__inner" };
const _hoisted_3 = { class: "product-detail-top__content" };
const _hoisted_4 = { class: "product-detail-top__media" };
const _hoisted_5 = { class: "product-detail-top__data" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetailTopLayout",
  props: {
    id: { default: "product-detail-top" }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: props.id,
        class: normalizeClass(["product-detail-top", "theme-light"])
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("div", _hoisted_4, [
              renderSlot(_ctx.$slots, "media")
            ]),
            createElementVNode("div", _hoisted_5, [
              renderSlot(_ctx.$slots, "data")
            ])
          ])
        ])
      ], 8, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
